import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { makeApiRequest } from '../axiosService/apiCall';
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { ImBubbles3 } from "react-icons/im";


function KYCdetails() {
    const [data, setData] = useState([]);
    const [selectedPassportImg, setSelectedPassportImg] = useState(null);
    const [selectedSelfieImg, setSelectedSelfieImg] = useState(null);
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [address, setAddress] = useState();
    const [filterStatus, setFilterStatus] = useState(null);
    const [processingRowId, setProcessingRowId] = useState(null);
    const [reason, setreason] = useState("");
    const userData = async () => {
        try {
            let params = {
                url: `kycDetails`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log('response', response)
            if (response.status) {
                const userData = response.kycData;

                if (response.status === true) {

                    setData(userData);
                } else {
                    setData([]);
                }
            } else {
                setData([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };
    const approvalData = async (status, id) => {
        setProcessingRowId(id); // Hide both buttons and show Processing...

        try {
            const swalResult = await Swal.fire({
                title: status === "approved" ? "Are you sure you want to Approve KYC?" : "Are you sure you want to Reject KYC?",
                icon: "question",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showCancelButton: true,
                showCloseButton: true,
                ...(status === "rejected" && {
                    html: '<label for="swal-input">Enter reason for rejection</label>' +
                        '<input id="swal-input" class="swal2-input" placeholder="Reason" maxlength="255">',
                    preConfirm: () => {
                        const rejectionReason = document.getElementById('swal-input').value;
                        if (!rejectionReason.trim()) {
                            Swal.showValidationMessage('Please provide a reason for rejection');
                            return false;
                        }
                        return rejectionReason;
                    }
                })
            });

            if (swalResult.isConfirmed) {
                setProcessingRowId(id); // Hide both buttons and show Processing...

                let payload = {
                    type: status,
                    id: id,
                    ...(status === "rejected" ? { reason: swalResult.value } : {}),
                };
                let params = {
                    url: `kycApproval`,
                    method: "POST",
                    data: payload,
                };
                const response = await makeApiRequest(params);

                // if (response.status) {
                //     toast.success(`User KYC ${status === "approved" ? "Approved" : "Rejected"} Successfully`);
                //     setProcessingRowId(null); // Show buttons again

                //     setTimeout(() => {
                //         userData();
                //     }, 2000);
                // }


                if (response.status) {
                    toast.success(`User KYC ${status === "approved" ? "Approved" : "Rejected"} Successfully`);

                    // ✅ Immediately update the UI without waiting for API refresh
                    setData(prevData =>
                        prevData.map(item =>
                            item._id === id
                                ? { ...item, KycStatus: status === "approved" ? 2 : 3 } 
                                : item
                        )
                    );

                    setProcessingRowId(null);
                    userData();
                }

            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setProcessingRowId(null); // Show buttons again
        }
    };



    useEffect(() => {
        userData();
    }, []);

    const handleViewImage = (passportImg, selfieImg) => {
        setSelectedPassportImg(passportImg);
        setSelectedSelfieImg(selfieImg);
    };
    const formatISTDate = (timestamp) => {
        if (!timestamp) return "-";

        const date = new Date(parseInt(timestamp));

        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };
    const columnsone = [
        {
            name: 'S.No',
            selector: row => row.time,
            sortable: true,
            width: "100px"
        },
        {
            name: 'Date of Apply',
            selector: row => !row.kycapplyDate || row.kycapplyDate.trim().length === 0
                ? "-"
                : formatISTDate(row.kycapplyDate),
            sortable: true,
            width: "200px"
        },
        {
            name: 'Name',
            selector: row => row.FirstName || "-",
            sortable: true,
            width: "200px"
        },
        {
            name: 'Email',
            selector: row => row.Email || "-",
            sortable: true,
            width: "350px"
        },
        {
            name: 'DateOfBirth',
            selector: row => row.DateOfBirth || "-",
            sortable: true,
            width: "140px"
        },
        {
            name: 'PhoneNumber',
            selector: row => row.PhoneNumber || "-",
            sortable: true,
            width: "150px"
        },
        {
            name: 'Address',
            selector: row => {
                // console.log({ row });

                const addressOne = row.AddressOne || "";
                const addressTwo = row.AddressTwo || "";

                return (addressOne && addressTwo)
                    ? `${addressOne}, ${addressTwo}`
                    : addressOne || addressTwo || "-";
            },
            sortable: true,
            width: "150px",
        },
        {
            name: 'Gender',
            selector: row => row.Gender || "-",
            sortable: true,
            width: "120px"
        },
        {
            name: 'Image',
            selector: row => row.image || "-",
            sortable: true,
            width: "300px"
        },
        {
            name: 'Action',
            selector: row => row.action,
            sortable: true,
            width: "300px"
        },
        // {
        //     name: 'Reject Reason',
        //     selector: row => row.Kycrejectreason?  row.Kycrejectreason:"N/A",
        //     sortable: true,
        //     width: "300px"
        // },
        {
            name: 'Reject Reason',
            selector: row => <div className='d-flex'>
                {row.Kycrejectreason
                    ? row.Kycrejectreason.substring(0, 20) + "..."
                    : "N/A"
                }
                {row.Kycrejectreason
                    ? <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#rejectReasonModal"
                        onClick={() => handleOpenModals(row.Kycrejectreason)}>
                        <ImBubbles3 />
                    </p>
                    : ""
                }
                {/* <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#rejectReasonModal"
                  onClick={() => handleOpenModal( row.Kycrejectreason)}>
                  <ImBubbles3 />
                </p> */}

                <div className="modal fade" id="rejectReasonModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="rejectReasonLabel" aria-hidden="true">
                    <div className="modal-dialog ">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="rejectReasonLabel">Reject Reason</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                                {reason || "No reason provided"}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,

            sortable: true,
            width: "350px"

        },
    ];
    const handleOpenModal = (data) => {
        setAddress(data);
    };
    const handleOpenModals = (data) => {
        setreason(data);
    };
    const dataone = (data && Array.isArray(data) ? data : [])
        .filter(row => row.KycStatus === 1 || row.KycStatus === 2 || row.KycStatus === 3)
        .map((row, index) => (
            {
                id: index + 1,
                time: index + 1,
                FirstName: row.PersonalDetails?.FirstName || "",
                kycapplyDate: row.PersonalDetails?.kycapplyDate || "",
                Email: row.email,
                DateOfBirth: row.PersonalDetails?.DateOfBirth || "",
                PhoneNumber: row.PersonalDetails?.PhoneNumber || "",
                Kycrejectreason: row.Kycrejectreason ? row.Kycrejectreason : "N/A",
                AddressOne: (
                    <div className='d-flex'>
                        {/* Show truncated AddressOne + AddressTwo preview */}
                        {((row.PersonalDetails?.AddressOne || "") + " " + (row.PersonalDetails?.AddressTwo || ""))
                            .length > 10
                            ? ((row.PersonalDetails?.AddressOne || "") + " " + (row.PersonalDetails?.AddressTwo || "")).substring(0, 10) + "..."
                            : (row.PersonalDetails?.AddressOne || "N/A") + " " + (row.PersonalDetails?.AddressTwo || "")
                        }
                        {((row.PersonalDetails?.AddressOne) || (row.PersonalDetails?.AddressTwo))
                            ? <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#staticBackdrop1"
                                onClick={() => handleOpenModal((row.PersonalDetails?.AddressOne || "") + " " + (row.PersonalDetails?.AddressTwo || ""))}>
                                <ImBubbles3 />
                            </p>
                            : ""
                        }


                        <div className="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel1" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5" id="staticBackdropLabel1">Address Details</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body" style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                                        {address || "No address available"}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                ),
                // AddressOne: row.PersonalDetails?.AddressOne || "-",
                Gender: row.PersonalDetails?.Gender || "",
                image: (
                    <button
                        className='table-btn'
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                            handleViewImage(
                                row.document?.PassPortImg || null,  // ✅ Prevents errors if PassPortImg is missing
                                row.document?.selfiePhoto || null   // ✅ Prevents errors if selfiePhoto is missing
                            )
                        }
                    >
                        {row.document?.PassPortImg || row.document?.selfiePhoto ? "View Image" : "No Image Available"}
                    </button>
                ),
                KycStatus: row.KycStatus,  // ✅ Ensure this is included
                action: (
                    <div className="d-flex align-items-center gap-3">
                        {row.KycStatus === 1 && (
                            <>
                                {processingRowId === row._id ? (
                                    <button className="processing" disabled>Processing...</button>
                                ) : (
                                    <>
                                        <button
                                            className='Aproval'
                                            onClick={() => approvalData('approved', row._id)}
                                        >
                                            Approve
                                        </button>
                                        <button
                                            className='pre-approval'
                                            onClick={() => approvalData('rejected', row._id)}
                                        >
                                            Reject
                                        </button>
                                    </>
                                )}
                            </>
                        )}
                        {row.KycStatus === 2 && <button className='Aproved' disabled>Approved</button>}
                        {row.KycStatus === 3 && <button className='reject' disabled>Rejected</button>}
                    </div>
                )



            }));

    const filteredData = dataone
        .filter(row => {
            const formattedDate = row.kycapplyDate ? formatISTDate(row.kycapplyDate) : "-";
            return (
                (row.Email && row.Email.trim() !== "" && row.Email.toLowerCase().includes(searchQuery.toLowerCase())) ||
                formattedDate.includes(searchQuery)
            );
        })
        .filter(row => (filterStatus !== null ? row.KycStatus === filterStatus : true)); // ✅ Ensure KycStatus filtering is applied correctly

    return (
        <div className='App'>
            <ToastContainer />
            <div className='container-fluid'>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 justify-content-center d-flex justify-content-between">
                                <h3 className="component-user text-center ms-lg-0">KYC Details</h3>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <input class="form-control form-search " type="text" placeholder="Search by Email or Date" aria-label="default input example" value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)} />
                                </div>
                                <div className='col-lg-6'>
                                    <div className="mb-3">
                                        <select
                                            className="form-select form-search"
                                            value={filterStatus ?? ''}
                                            onChange={(e) => setFilterStatus(e.target.value ? Number(e.target.value) : null)}
                                        >
                                            <option value="">All</option>
                                            <option value="1">Pending</option>
                                            <option value="2">Approved</option>
                                            <option value="3">Rejected</option>
                                        </select>

                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='custom-datascroll'>
                                        <DataTable columns={columnsone} data={filteredData} theme="solarized" defaultSortAsc={true}
                                            pagination
                                            highlightOnHover
                                            dense />
                                    </div>
                                </div>
                            </div>
                            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">Upload Image</h5>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <div>
                                                <h5>Passport Image</h5>
                                                <img src={selectedPassportImg} alt="Passport" className="img-fluid" />
                                            </div>
                                            <div className="mt-3">
                                                <h5>Selfie Image</h5>
                                                <img src={selectedSelfieImg} alt="Selfie" className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default KYCdetails;
